export default "__VITE_ASSET__D1DMH_Hl__"